import { render, staticRenderFns } from "./DocumentKeywordsList.vue?vue&type=template&id=4c4a0e24"
import script from "./DocumentKeywordsList.vue?vue&type=script&lang=js"
export * from "./DocumentKeywordsList.vue?vue&type=script&lang=js"
import style0 from "./DocumentKeywordsList.vue?vue&type=style&index=0&id=4c4a0e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports